import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiGetPaymentHistory } from "services/SubscriptionService";

export const getPaymentHistory = createAsyncThunk(
  "paymentHistory/getPaymentHistory",
  async (partnerId) => {
    const response = await apiGetPaymentHistory(partnerId);
    return response.data;
  }
);

const paymentHistorySlice = createSlice({
  name: "paymentHistory",
  initialState: {
    loading: false,
    history: [],
    tableData: {
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      query: "",
      sort: {
        order: "",
        key: "",
      },
    },
    error: null,
  },
  reducers: {
    setTableData: (state, action) => {
      state.tableData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPaymentHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.history = action.payload?.data || [];
        state.tableData.total = action.payload?.data?.length || 0;
      })
      .addCase(getPaymentHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setTableData } = paymentHistorySlice.actions;

export default paymentHistorySlice.reducer;